import { render, staticRenderFns } from "./FollowDrawer.vue?vue&type=template&id=0701c7f4"
import script from "./FollowDrawer.vue?vue&type=script&lang=js"
export * from "./FollowDrawer.vue?vue&type=script&lang=js"
import style0 from "./FollowDrawer.vue?vue&type=style&index=0&id=0701c7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports